import React, { useState, useEffect } from "react";
import {
	Typography,
	Select,
	MenuItem,
	FormControl,
	Button,
	SwipeableDrawer,
	Checkbox,
	ListItemText,
	FormGroup,
	FormControlLabel,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { useStore } from "@store/store";
import filterIcon from "@assets/images/filter-icon.svg";
import closeIcon from "@assets/images/close.svg";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIcon from "@assets/images/checked-icon.svg";
import {
	GET_JOBTYPES,
	GET_JOBTYPES_SUCCESS,
	GET_JOBTYPES_FAILURE,
	GET_CARGO_TYPE,
	GET_CARGO_TYPE_SUCCESS,
	GET_CARGO_TYPE_FAILURE,
	GET_REQUEST_STATUS,
	GET_REQUEST_STATUS_SUCCESS,
	GET_REQUEST_STATUS_FAILURE,
	GET_JOB_STATUS,
	GET_JOB_STATUS_SUCCESS,
	GET_JOB_STATUS_FAILURE,
	GET_CITIES,
	GET_CITIES_SUCCESS,
	GET_CITIES_FAILURE,
	GET_CTOS,
	GET_CTOS_SUCCESS,
	GET_CTOS_FAILURE,
} from "@utils/actionTypes";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { getCustomFormToDate, getCityIds } from "@utils/commonFunctions";
import Popup from "./popup";
import { getApi } from "@services/axios";
import { reportFilterStyle } from "./style";

function OnlineReportFilter(props) {
	const classes = reportFilterStyle();
	const materilClasses = materialCommonStyles();
	const [state, dispatch] = useStore();
	const [allMenuData, setAllMenuData] = useState({
		jobTypeMenuData: [],
		requestStatusMenuData: [],
		jobStatusMenuData: [],
		ctoMenuData: [],
		cargoTypeMenuData: [],
	});

	const handleSetMenuData = (stateName, name) => {
		const arr = [];
		stateName?.map((item) => {
			arr.push({
				label: item.name,
				value: item.id,
			});
			return true;
		});
		setAllMenuData((prevState) => ({
			...prevState,
			[name]: arr,
		}));
	};

	useEffect(() => {
		handleSetMenuData(state?.common?.jobTypeData, "jobTypeMenuData");
		handleSetMenuData(state?.common?.jobStatusData, "jobStatusMenuData");
		handleSetMenuData(
			state?.common?.requestStatusData,
			"requestStatusMenuData"
		);
		handleSetMenuData(state?.common?.ctosData, "ctoMenuData");
		handleSetMenuData(state?.common?.cargoTypeData, "cargoTypeMenuData");

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		state?.common?.jobTypeData,
		state?.common?.jobStatusData,
		state?.common?.requestStatusData,
		state?.common?.ctosData,
		state?.common?.cargoTypeData,
	]);

	useEffect(() => {
		if (state?.common?.citiesData === null) {
			dispatch({ type: GET_CITIES });
			getApi("master/cities", null, false)
				.then((response) => {
					dispatch({
						type: GET_CITIES_SUCCESS,
						payload: response.data.data,
					});
				})
				.catch((error) => {
					dispatch({ type: GET_CITIES_FAILURE, payload: error });
				});
		}

		if (state?.common?.jobStatusData === null) {
			dispatch({ type: GET_JOB_STATUS });
			getApi("master/jobStatuses", null, false)
				.then((response) => {
					dispatch({
						type: GET_JOB_STATUS_SUCCESS,
						payload: response.data.data,
					});
				})
				.catch((error) => {
					dispatch({ type: GET_JOB_STATUS_FAILURE, payload: error });
				});
		}

		if (state?.common?.jobTypeData === null) {
			dispatch({ type: GET_JOBTYPES });
			getApi("master/jobTypes", null, false)
				.then((response) => {
					dispatch({
						type: GET_JOBTYPES_SUCCESS,
						payload: response.data.data,
					});
				})
				.catch((error) => {
					dispatch({ type: GET_JOBTYPES_FAILURE, payload: error });
				});
		}

		if (state?.common?.requestStatusData === null) {
			dispatch({ type: GET_REQUEST_STATUS });
			getApi("master/onlineRequestStatuses", null, false)
				.then((response) => {
					dispatch({
						type: GET_REQUEST_STATUS_SUCCESS,
						payload: response.data.data,
					});
				})
				.catch((error) => {
					dispatch({ type: GET_REQUEST_STATUS_FAILURE, payload: error });
				});
		}

		if (state?.common?.cargoTypeData === null) {
			dispatch({ type: GET_CARGO_TYPE });
			getApi("master/cargoTypes", null, false)
				.then((response) => {
					dispatch({
						type: GET_CARGO_TYPE_SUCCESS,
						payload: response.data.data,
					});
				})
				.catch((error) => {
					dispatch({ type: GET_CARGO_TYPE_FAILURE, payload: error });
				});
		}

		if (state?.common?.ctosData === null) {
			const params = {
				cityId: getCityIds(),
			};
			dispatch({ type: GET_CTOS });
			getApi("master/ctos", { params }, false)
				.then((response) => {
					dispatch({
						type: GET_CTOS_SUCCESS,
						payload: response.data.data,
					});
				})
				.catch((error) => {
					dispatch({ type: GET_CTOS_FAILURE, payload: error });
				});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className={classes.RequestFilterWrapper}>
			{["right"].map((anchor) => (
				<React.Fragment key={anchor}>
					<Button
						className="primary-btn blue-btn lg"
						variant="contained"
						color="primary"
						disableElevation
						onClick={props.toggleDrawer(anchor, true)}
					>
						<img src={filterIcon} alt="Filter" />
						Filter
					</Button>
					<SwipeableDrawer
						className={classes.drawerWrapper}
						anchor={anchor}
						open={props.getState[anchor]}
						onClose={props.toggleDrawer(anchor, false)}
						onOpen={props.toggleDrawer(anchor, true)}
					>
						<div className="drawer-wrapper">
							<div className="filter-form">
								<form noValidate autoComplete="off" className="custom-form">
									<div className="form-row">
										<div className="filter-title-block form-group">
											<Typography variant="h2">Filter</Typography>
											<img
												src={closeIcon}
												alt="Close"
												onClick={props.toggleDrawer(anchor, false)}
											/>
										</div>
										<div className="form-gourp">
											<div className="label-wrapper">
												<label className="label-text">Type of Job</label>
											</div>
											<FormControl
												variant="outlined"
												className={classes.formControl}
											>
												<Select
													name="jobType"
													value={props.filterData?.jobType}
													onChange={(e) => props.handleFilter(e)}
													displayEmpty
													className={materilClasses.customSelect}
													MenuProps={{
														classes: { paper: materilClasses.customSelect },
													}}
													IconComponent={() => <ExpandMore />}
													multiple
													renderValue={(selected) => {
														if (selected.length === 0) {
															return <> Select job type</>;
														}

														return allMenuData.jobTypeMenuData
															.filter((m) => selected.includes(m.value))
															.map((m) => m.label)
															.join(", ");
													}}
												>
													<MenuItem value="" disabled>
														Select Job Type
													</MenuItem>
													{allMenuData.jobTypeMenuData
														.filter((item) => {
															return [
																"Import",
																"Export",
																"Empty",
																"Temp Control",
															].includes(item.label);
														})
														.map((item, index) => {
															return (
																<MenuItem
																	key={index}
																	value={item.value}
																	className="custom-checkbox custom-Multicheckbox"
																>
																	<Checkbox
																		checked={
																			props.filterData.jobType.indexOf(
																				item.value
																			) > -1
																		}
																		icon={
																			<img src={uncheckedIcon} alt="CheckBox" />
																		}
																		checkedIcon={
																			<img src={checkedIcon} alt="CheckBox" />
																		}
																	/>
																	<ListItemText primary={item.label} />
																</MenuItem>
															);
														})}
												</Select>
											</FormControl>
										</div>

										{props.getTab === 3 ? (
											<div className="form-gourp">
												<div className="label-wrapper">
													<label className="label-text">Cargo Type</label>
												</div>
												<FormControl
													variant="outlined"
													className={classes.formControl}
												>
													<Select
														name="AWBCargoType"
														value={props.filterData.AWBCargoType}
														onChange={(e) => props.handleFilter(e)}
														displayEmpty
														className={materilClasses.customSelect}
														MenuProps={{
															classes: { paper: materilClasses.customSelect },
														}}
														IconComponent={() => <ExpandMore />}
														multiple
														renderValue={(selected) => {
															if (selected.length === 0) {
																return <> Select CargoType</>;
															}

															return allMenuData.cargoTypeMenuData
																.filter((m) => selected.includes(m.value))
																.map((m) => m.label)
																.join(", ");
														}}
													>
														<MenuItem value="" disabled>
															Select CargoType
														</MenuItem>
														{allMenuData.cargoTypeMenuData.map(
															(item, index) => {
																return (
																	<MenuItem
																		key={index}
																		value={item.value}
																		className="custom-checkbox custom-Multicheckbox"
																	>
																		<Checkbox
																			checked={
																				props.filterData.AWBCargoType.indexOf(
																					item.value
																				) > -1
																			}
																			icon={
																				<img
																					src={uncheckedIcon}
																					alt="CheckBox"
																				/>
																			}
																			checkedIcon={
																				<img src={checkedIcon} alt="CheckBox" />
																			}
																		/>
																		<ListItemText primary={item.label} />
																	</MenuItem>
																);
															}
														)}
													</Select>
												</FormControl>
											</div>
										) : (
											<div className="form-gourp">
												<div className="label-wrapper">
													<label className="label-text">Cargo Type</label>
												</div>
												<FormControl
													variant="outlined"
													className={classes.formControl}
												>
													<Select
														name="cargoType"
														value={props.filterData?.cargoType}
														onChange={(e) => props.handleFilter(e)}
														displayEmpty
														className={materilClasses.customSelect}
														MenuProps={{
															classes: { paper: materilClasses.customSelect },
														}}
														IconComponent={() => <ExpandMore />}
													>
														<MenuItem value={""}>Select Cargo Type</MenuItem>
														{state?.common?.loadingCargoType ? (
															<MenuItem>Loading...</MenuItem>
														) : (
															state?.common?.cargoTypeData?.map(
																(item, index) => {
																	return (
																		<MenuItem key={index} value={item.id}>
																			{item.name}
																		</MenuItem>
																	);
																}
															)
														)}
													</Select>
												</FormControl>
											</div>
										)}
										{props.getTab !== 3 && (
											<div className="form-gourp">
												<div className="label-wrapper">
													<label className="label-text">Request Status</label>
												</div>
												<FormControl
													variant="outlined"
													className={classes.formControl}
												>
													<Select
														name="requestStatus"
														value={props.filterData?.requestStatus}
														onChange={(e) => props.handleFilter(e)}
														displayEmpty
														className={materilClasses.customSelect}
														MenuProps={{
															classes: { paper: materilClasses.customSelect },
														}}
														IconComponent={() => <ExpandMore />}
														multiple
														renderValue={(selected) => {
															if (selected.length === 0) {
																return <> Select Request Status</>;
															}

															return allMenuData.requestStatusMenuData
																.filter((m) => selected.includes(m.value))
																.map((m) => m.label)
																.join(", ");
														}}
													>
														<MenuItem value="" disabled>
															Select Request Status
														</MenuItem>
														{allMenuData.requestStatusMenuData.map(
															(item, index) => {
																return (
																	<MenuItem
																		key={index}
																		value={item.value}
																		className="custom-checkbox custom-Multicheckbox"
																	>
																		<Checkbox
																			checked={
																				props.filterData.requestStatus.indexOf(
																					item.value
																				) > -1
																			}
																			icon={
																				<img
																					src={uncheckedIcon}
																					alt="CheckBox"
																				/>
																			}
																			checkedIcon={
																				<img src={checkedIcon} alt="CheckBox" />
																			}
																		/>
																		<ListItemText primary={item.label} />
																	</MenuItem>
																);
															}
														)}
													</Select>
												</FormControl>
											</div>
										)}
										<div className="form-gourp">
											<div className="label-wrapper">
												<label className="label-text">Job Status</label>
											</div>
											<FormControl
												variant="outlined"
												className={classes.formControl}
											>
												<Select
													value={props.filterData?.jobStatus}
													name="jobStatus"
													onChange={(e) => props.handleFilter(e)}
													displayEmpty
													className={materilClasses.customSelect}
													MenuProps={{
														classes: { paper: materilClasses.customSelect },
													}}
													IconComponent={() => <ExpandMore />}
													multiple
													renderValue={(selected) => {
														if (selected.length === 0) {
															return <> Select Job Status</>;
														}

														return allMenuData.jobStatusMenuData
															.filter((m) => selected.includes(m.value))
															.map((m) => m.label)
															.join(", ");
													}}
												>
													<MenuItem value="" disabled>
														Select Job Status
													</MenuItem>
													{allMenuData.jobStatusMenuData.map((item, index) => {
														return (
															<MenuItem
																key={index}
																value={item.value}
																className="custom-checkbox custom-Multicheckbox"
															>
																<Checkbox
																	checked={
																		props.filterData.jobStatus.indexOf(
																			item.value
																		) > -1
																	}
																	icon={
																		<img src={uncheckedIcon} alt="CheckBox" />
																	}
																	checkedIcon={
																		<img src={checkedIcon} alt="CheckBox" />
																	}
																/>
																<ListItemText primary={item.label} />
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</div>

										<div className="form-gourp">
											<div className="label-wrapper">
												<label className="label-text">CTO</label>
											</div>
											<FormControl
												variant="outlined"
												className={classes.formControl}
											>
												<Select
													value={props.filterData?.cto}
													onChange={(e) => props.handleFilter(e)}
													name="cto"
													displayEmpty
													className={materilClasses.customSelect}
													MenuProps={{
														classes: { paper: materilClasses.customSelect },
													}}
													IconComponent={() => <ExpandMore />}
													multiple
													renderValue={(selected) => {
														if (selected.length === 0) {
															return <> Select cto</>;
														}

														return allMenuData.ctoMenuData
															.filter((m) => selected.includes(m.value))
															.map((m) => m.label)
															.join(", ");
													}}
												>
													<MenuItem value="" disabled>
														Select cto
													</MenuItem>
													{allMenuData.ctoMenuData.map((item, index) => {
														return (
															<MenuItem
																key={index}
																value={item.value}
																className="custom-checkbox custom-Multicheckbox"
															>
																<Checkbox
																	checked={
																		props.filterData.cto.indexOf(item.value) >
																		-1
																	}
																	icon={
																		<img src={uncheckedIcon} alt="CheckBox" />
																	}
																	checkedIcon={
																		<img src={checkedIcon} alt="CheckBox" />
																	}
																/>
																<ListItemText primary={item.label} />
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</div>
										<div className="form-gourp">
											<div className="label-wrapper">
												<label className="label-text">Reporting period</label>
											</div>
											<FormControl
												variant="outlined"
												className={classes.formControl}
											>
												<Select
													value={props.period}
													onChange={props.handlePeriodChange}
													placeholder="06/12/2021"
													displayEmpty
													className={materilClasses.customSelect}
													MenuProps={{
														classes: { paper: materilClasses.customSelect },
													}}
													IconComponent={() => <ExpandMore />}
												>
													<MenuItem value={""}>Select Period</MenuItem>
													<MenuItem value={1}>Today</MenuItem>
													<MenuItem value={2}>Yesterday</MenuItem>
													<MenuItem value={3}>Last 3 days</MenuItem>
													<MenuItem value={4}>Last 7 days</MenuItem>
													<MenuItem value={5}>Last fortnight</MenuItem>
													<MenuItem value={6}>Last 30 days</MenuItem>
													<MenuItem
														value={7}
														onClick={(e) => props.handlePeriodChange(e, true)}
													>
														{props.show &&
														props.customDate.startDate &&
														props.customDate.endDate
															? getCustomFormToDate(
																	props.customDate.startDate,
																	props.customDate.endDate
															  )
															: "Custom Range"}
													</MenuItem>
												</Select>
												<Popup
													open={props.open}
													handleSubmit={props.handleCustomDateSubmit}
													handleClose={props.handleClose}
													data={props.customDate}
													handleChange={(e, type) =>
														props.handleCustomChange(e, type)
													}
												/>
												<Popup
													open={props.open}
													handleSubmit={props.handleCustomDateSubmit}
													handleClose={props.handleClose}
													data={props.customDate}
													handleChange={(e, type) =>
														props.handleCustomChange(e, type)
													}
												/>
											</FormControl>
										</div>
										{props.getTab === 3 && (
											<div className="form-group">
												<FormControl component="fieldset">
													<FormGroup
														aria-label="position"
														className="custom-checkbox"
													>
														<FormControlLabel
															value="end"
															control={
																<Checkbox
																	name="notFullyLoaded"
																	icon={
																		<img src={uncheckedIcon} alt="CheckBox" />
																	}
																	checkedIcon={
																		<img src={checkedIcon} alt="CheckBox" />
																	}
																	checked={props.filterData?.notFullyLoaded}
																	value={props.filterData?.notFullyLoaded}
																	onChange={(e) => props.handleFilter(e)}
																/>
															}
															label="AWB not taken fully"
															labelPlacement="end"
														/>
													</FormGroup>
												</FormControl>
											</div>
										)}
									</div>
								</form>
							</div>
						</div>
						<div className="button-wrapper">
							<div className="button-wrapper-inner">
								<Button
									className="primary-btn gray-border-btn btn"
									color="inherit"
									disableElevation
									onClick={() => props.handleReset(anchor)}
								>
									RESET
								</Button>
								<Button
									className="orange-btn primary-btn btn"
									color="inherit"
									disableElevation
									onClick={() => props.handleSubmit(anchor)}
								>
									APPLY
								</Button>
							</div>
						</div>
					</SwipeableDrawer>
				</React.Fragment>
			))}
		</div>
	);
}

export default OnlineReportFilter;
